import { NFTS_NETWORK_TO_ASSET_NAME } from '@exodus/nfts/constants';

import type { Nft } from '../types/index.js';

export const getChainFromNft = ({ network }: Nft = {} as Nft): string => {
  // TODO, stop relaying on the hardcoded NFTS_NETWORK_TO_ASSET_NAME
  return NFTS_NETWORK_TO_ASSET_NAME[network] || network;
};
